// Node imports
import { IEvent, delayedCall, dispatcher, ingenuity,killDelayedCall } from "@quest/base-core";
import { WinPresentationController, SlotEventConstantsBehavior } from "@quest/murka-games-behavior-leopard/dist";
import { SlotEventConstants, SlotConstants } from "@quest/slot-core/dist";
import { GameParserModel } from "../Platform/GameParserModel";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { SoundConstantGame } from "../Constants/SoundConstantGame";
import { gameConstants } from "../Constants/gameConstants";

export class WinPresentationControllerGame extends WinPresentationController {
  // override to handle stack
  protected onShowAllFrames(evt: IEvent): void {
    const windata = (ingenuity.parserModel as GameParserModel).getLinesWinAllUniquePositions();
    for (let a of windata) {
      if (this.view.getReelView().getSymbolByPos(a[0], a[1]).symNum == 0) {
        (ingenuity.soundManager as any).playSound(SoundConstantGame.SFX_WILD, 0.8, false, gameConstants.SOUND_LIST_PRELOAD);
      }
    }
    dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_BASEGAME_WIN_ALPHA_ON_SYMBOL, windata);
    const purpleWild: number[] = ingenuity.configData.checkForLastFlower;
    if ((ingenuity.parserModel as GameParserModel).getWildOnReel().length || purpleWild.length > 0) {
      dispatcher.fireEvent(eventDispatchers.PLAY_WILD_DRAGON_WIN_ANIM)
    }
    if (this.paylineView) {
      this.view.addChild(this.view.getMeterById("winMtr")); // to bring winmeter on top of win frames
      if (this.model.getIsAutoPlayLeft() && !this.model.getIsBigWin() && !(ingenuity.parserModel as GameParserModel).getSelectionScreenAvailable()) {
        dispatcher.fireEvent(SlotEventConstants.SHOW_ALL_FRAMES, {
          callback() {
            //
          },
          callbackScope: this,
          delayTimer: this.model.getDelayForSpaghttiDispaly(),
          winData: windata
        });
      }
      else if ((ingenuity.parserModel as GameParserModel).getHasLineWins()) {
        this.onShowAllFramesComplete();
      }
      else {
        if (this.model.getIsScatterWins()) {
          dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
        }
      }
    }
    else {
      dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
    }
    // Play all anim with delay to show stack before static hide.
    if ((ingenuity.parserModel as GameParserModel).getStackSymPresent() && (ingenuity.parserModel as GameParserModel).getCommonOffsetsOfStackAndWin().length > 0) {
      delayedCall("playAnimDelayForStack", 100, () => {
        killDelayedCall("playAnimDelayForStack");
        dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_ALL_SYMBOL_ANIM);
      }, this)
    } else {
      dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_ALL_SYMBOL_ANIM);

    }
  }
  /**
   * Method to run on onShowAllFrames Completed
   */
  private onShowAllFramesComplete(): void {
    const windata: number[][] = (ingenuity.parserModel as GameParserModel).getLinesWinAllUniquePositions();
    dispatcher.fireEvent(SlotEventConstants.SHOW_ALL_FRAMES, {
      callback() {
        dispatcher.fireEvent(SlotEventConstants.HIDE_ALL_FRAMES);
        dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
      },
      callbackScope: this,
      delayTimer: this.model.getDelayForSpaghttiDispaly(),
      winData: windata
    });
  }
  /**
   * overrided to update grid with disabled onion on win suspend
   */
  protected onSuspendWinPresentation(): void {
    ingenuity.configData.playAllSymbolAnim = true;
    super.onSuspendWinPresentation();
    this.suspendSound();
    if ((ingenuity.parserModel as GameParserModel).getOnionOffset().length) {
      (ingenuity.parserModel as GameParserModel).getCurrentBetGrid() && (ingenuity.parserModel as GameParserModel).getCurrentBetGrid().length ?
        dispatcher.fireEvent(eventDispatchers.ADD_DISABLED_ONION_ON_REEL, (ingenuity.parserModel as GameParserModel).getCurrentBetGrid()) :
        dispatcher.fireEvent(eventDispatchers.ADD_DISABLED_ONION_ON_REEL, (ingenuity.parserModel as GameParserModel).getReelGrid());
    }
    
    dispatcher.fireEvent(eventDispatchers.UPDATE_GRID_ON_LAST_WILD);
    this.symbolSoundArray = [];
    if (ingenuity.configData.playAllSymbolAnim) {
      dispatcher.fireEvent(eventDispatchers.RESET_TOGGLE_SOUND_COUNTER);
      
      dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_ALL_SYMBOL_ANIM);
    }
  }
  /**
   * overirded to remove off dispatcher to fix bet change issue
   */
  protected onStopAllWinAnimation(): void {
    if (this.paylineView) {
      delayedCall(SlotConstants.TimerHidePayline, this.model.getFadeOutTimeWinBox(), function () {
        dispatcher.fireEvent(SlotEventConstants.HIDE_ALL_SPAGETTI);
        dispatcher.fireEvent(SlotEventConstants.HIDE_ALL_FRAMES);
        dispatcher.fireEvent(SlotEventConstants.HIDE_ALL_WIN_PAYLINE);
      }, this);
    }
    dispatcher.fireEvent(SlotEventConstants.STOP_ALL_WIN_ANIMATIONS);
  }
  // Overrided to handle chilli trail stage click
  protected onStageClicked(): void {
    if (ingenuity.configData.enableStageClick) {
      if (ingenuity.configData.isAutoplayActive) {
        dispatcher.fireEvent(SlotEventConstants.DISABLE_BUTTON, [SlotConstants.SpinBtnId]);
      }
      if (this.model.getIsBigWinRunning()) {
        dispatcher.fireEvent(SlotEventConstants.SUMUP_BIGWIN);
        dispatcher.fireEvent(SlotEventConstantsBehavior.CLEAR_BIG_WIN);
      }
      ingenuity.configData.enableStageClick = false;
    }
    if (ingenuity.configData.enableStageClickOnFirstToggle) {
      if (this.paylineView) {
        dispatcher.fireEvent(SlotEventConstants.HIDE_ALL_SPAGETTI);
        dispatcher.fireEvent(SlotEventConstants.HIDE_ALL_FRAMES);
        dispatcher.fireEvent(SlotEventConstants.HIDE_ALL_WIN_PAYLINE);
        dispatcher.fireEvent(SlotEventConstants.STOP_METER_TICKUP);
        dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_SYMBOL_SOUND);
        ingenuity.soundManager.stop(this.model.getWinMeterTickUpSound());
      }
      dispatcher.fireEvent(SlotEventConstants.STOP_ALL_WIN_ANIMATIONS);
      dispatcher.off(SlotEventConstants.WIN_CYCLE_COMPLETED, this.onWinCycleCompleted);
      ingenuity.configData.stopWinAnimOnSecondToggle = true;
      dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_STAGE_CLICK_PLAYER_MSG);
      // Add some delay to call next win presentation after clearSymReel function call so that scatter trigger animation play after stage click
      delayedCall(
        "nextWinPresentationDelay",
        20,
        () => {
          killDelayedCall("nextWinPresentationDelay");
          dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
        },
        this
      );
      ingenuity.configData.enableStageClickOnFirstToggle = false;
      ingenuity.configData.stopWinAnimOnSecondToggle = false;
      dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_ALL_SYMBOL_ANIM);
    }
  }
  /**
   * Method to stop sound.
   */
  private suspendSound(): void {
    if ((ingenuity.soundManager as any).getSoundInstance(SoundConstantGame.VOICE_INTRO, gameConstants.SOUND_LIST_PRELOAD)) {
      (ingenuity.soundManager as any).stop(SoundConstantGame.VOICE_INTRO, gameConstants.SOUND_LIST_PRELOAD)
    }
    if ((ingenuity.soundManager as any).getSoundInstance(SoundConstantGame.STACK_WIN, gameConstants.SOUND_LIST_PRELOAD)) {
      (ingenuity.soundManager as any).stop(SoundConstantGame.STACK_WIN, gameConstants.SOUND_LIST_PRELOAD);
    }
    if ((ingenuity.soundManager as any).getSoundInstance(SoundConstantGame.WILD_WIN, gameConstants.SOUND_LIST_PRELOAD)) {
      (ingenuity.soundManager as any).stop(SoundConstantGame.WILD_WIN, gameConstants.SOUND_LIST_PRELOAD);
    }
  }
}
